import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import ModalComponent from "../../../components/modals/ModalComponent";
import MyInput from "../formElements/Input";
import MyRadio from "../formElements/Radio";
import MyCheckBox from "../formElements/CheckBox";
import MyDropdown from "../formElements/Dropdown";
import MyDatePicker from "../formElements/DatePicker";
import YesNo from "../../../components/questionContainer/formElements/YesNo";
import LoadableButton from "../../../components/button/LoadableButton";
import { AddUpdateAnswerApi } from "../../../api/request/service";

const AnswerModal = ({
  isOpen,
  setIsOpen,
  question,
  reloadQuestions,
  updateAnswer,
}) => {
  const [answer, setAnswer] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setAnswer(question?.response_text);
  }, [question]);

  const QuestionRender = (question) => {
    switch (question?.field_type) {
      case "input":
        return <MyInput data={question} setAnswer={setAnswer} />;
      case "email":
        return <MyInput data={question} setAnswer={setAnswer} />;
      case "number":
        return <MyInput data={question} setAnswer={setAnswer} />;
      case "date":
        return <MyDatePicker data={question} setAnswer={setAnswer} />;
      case "radio":
        return <MyRadio data={question} setAnswer={setAnswer} />;
      case "checkbox":
        return <MyCheckBox data={question} setAnswer={setAnswer} />;
      case "dropdown":
        return <MyDropdown data={question} setAnswer={setAnswer} />;
      case "yes-no":
        return <YesNo data={question} setAnswer={setAnswer} />;
      default:
        return null;
    }
  };

  const onSubmit = async () => {
    if (!answer) return;
    try {
      setIsLoading(true);
      const params = {
        id: question?.id,
        response_text: answer,
      };
      const { data } = await AddUpdateAnswerApi(params);
      if (data?.status) {
        if (updateAnswer) updateAnswer(params);
        setIsOpen(false);
        reloadQuestions();
      }
      setIsLoading(false);
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
      setIsLoading(false);
    }
  };

  return (
    <ModalComponent
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={"Update Answer"}
    >
      <div className="flex flex-col gap-5">
        {QuestionRender(question)}

        <div className="flex justify-center">
          <LoadableButton
            className="bg-primary text-white uppercase text-base font-semibold px-6 py-2 rounded-lg mt-2"
            type="submit"
            lable="Update"
            loadingLable="Updating Answer..."
            isLoading={isLoading}
            onClick={onSubmit}
          />
        </div>
      </div>
    </ModalComponent>
  );
};

export default AnswerModal;
